module.exports = __webpack_public_path__ + "fonts/StagSans-Book-Italic.otf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Book-Italic.otf
// module id = 1089
// module chunks = 0